<template>
  <div>
    <a-card style="width:100%;text-align:center;">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" style="margin:20px 0px 0px 20px;" v-model="query">
          <a-row :gutter="24">
            <a-col :md="5" :sm="12">
              <a-form-item>
                <a-select
                  v-model="query.qualityId"
                  placeholder="选择设备安装地址"
                  @change="handleDeviceAddressChange"
                >
                  <a-select-option v-for="item in deviceList" :key="item.id">{{ item.address }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="12">
              <a-form-item>
                <a-select
                  v-model="query.type"
                  v-decorator="[
                    'gender',
                    { rules: [{ required: true, message: 'Please select your gender!' }] },
                  ]"
                  placeholder="选择指标来源"
                >
                  <a-select-option v-for="item in indexSourceList" :key="item.type">{{ item.typeName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="12">
              <a-form-item>
                <a-select
                  v-model="query.filedName"
                  v-decorator="[
                    'gender',
                    { rules: [{ required: true, message: 'Please select your gender!' }] },
                  ]"
                  placeholder="选择指标类型"
                  @change="handleTypeResultParameterChange"
                >
                  <a-select-option v-for="item in typeResultParameterList" :key="item.filedName">{{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item>
                <a-range-picker
                  :default-value="[
                   moment(getCurrentData(), 'YYYY-MM-DD'),
                   moment(getCurrentData(),  'YYYY-MM-DD'),
                  ]"
                  :show-time="{ format: 'YYYY-MM-DD' }"
                  format="YYYY-MM-DD"
                  :placeholder="['查询开始', '查询结束']"
                  @change="queryOnChange"
                  v-model="queryTime"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="18">
            <a-col :md="6" :sm="12">
              <a-form-item>
                <a-range-picker
                  v-model="contrastTime"
                  :show-time="{ format: 'YYYY-MM-DD' }"
                  format="YYYY-MM-DD"
                  :placeholder="['请选择对比开始时间', '对比结束时间']"
                  @change="contrastOnChange"

                />
              </a-form-item>
            </a-col>
            <a-col :md="3" :sm="12">
              <a-form-item>
                <a-button type="primary" @click="queryList" style="margin-left: 80%">搜索</a-button>
              </a-form-item>
            </a-col>
            <a-col :md="3" :sm="12">
              <a-form-item>
                <a-button type="primary" @click="contrast">对比</a-button>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div id="chart">

      </div>
    </a-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import * as echarts from 'echarts'

export default {
  mixins: [mixinViewModule],
  data() {
    return {
      deviceList: [],
      indexSourceList: [],
      typeResultParameterList: [],
      id: '',
      chartDom: null,
      myChart: null,
      title: '浊度',
      subtitle: '进厂水',
      firstName: '',
      option: {},
      legend: [],
      queryUrl: '/pipe-network/water_works_malfunctions/page',
      deleteUrl: '/pipe-network/water_works_malfunctions/',
      modifyUrl: '/pipe-network/water_works_malfunctions',
      list: [],
      queryDate: [],
      queryData: [],
      contrastDate: [],
      contrastData: [],
      contrastTime: '',
      queryTime: '',
      ischangeTime: false,
      defaulttime: '',
      defaultcontrasttime: '',
      defaultbegintime:'',
      defaultendtime: '',
      defaultcontrastBeginTime: '',
      defaultcontrastEndTime: '',
      query: {
        qualityId: '',
        contrastTime: '',
        tenantId: this.$store.state.user.info.tenantId,
        deviceNo: '',
        queryBeginTime: '',
        queryEndTime: '',
        contrastBeginTime: '',
        contrastEndTime: '',
        filedName: '',
        type: ''
      }
    }
  },
  computed: {
    currentUser() {
      return this.$store.getters.userInfo
    },
    token() {
      return this.$store.getters.token
    }
  },
  mounted() {
    this.echartsInit()
  },
  created() {
    this.getDeviceList()
    this.defaultbegintime = this.getCurrentData()
    this.defaultendtime = this.getCurrentData()
    this.setDefaultTime(this.defaultbegintime,this.defaultendtime);
  },
  methods: {
    echartsInit() {
      // let starttime = this.ischangeTime == false ? this.moment().format(this.defaultbegintime, 'YYYY-MM-DD') : this.moment().format(this.query.queryBeginTime, 'YYYY-MM-DD');
      // let endtime = this.ischangeTime == false ? this.moment().format(this.defaultendtime, 'YYYY-MM-DD') : this.moment().format(this.query.queryEndTime, 'YYYY-MM-DD');
      console.log(this.defaulttime);
      // if(this.legend.length > 0){
      //   this.legend[0] = this.defaulttime;
      //   // this.option.series[0].name = this.defaulttime;
      //   console.log(this.legend.length);
      // }else{
      //   console.log(this.legend.length);
      //   this.legend = [];
      // }
      this.chartDom = document.getElementById('chart')
      this.myChart = echarts.init(this.chartDom)
      this.option = {
        title: {
          text: this.title,
          subtext: this.subtitle,
          textStyle: {
            color: 'rgb(47 84 235)'
          },
          textAlign: 'auto',
          left: 15
        },
        legend: {
          data: this.legend
        },
        tooltip: {
          trigger: 'axis',
          // label:{
          //   width:'100px'
          // }
        },
        grid: {
          show: true,
          left: 50,
          right: 50
        },
        xAxis: {
          type: 'category',
          data: this.queryDate
        },
        yAxis: {
          type: 'value'
        },
        dataZoom: [
          {
            show: true,
            realtime: true,
            start: 0,
            end: 100,
            xAxisIndex: [0, 1]
          },
          {
            type: 'inside',
            realtime: true,
            start: 0,
            end: 5,
            xAxisIndex: [0, 1]
          }
        ],
        color: ['#5470c6', '#e66'],
        series: [
          {
            name: this.firstName,
            data: this.queryData,
            type: 'line',
            label: {
              show: true
            },
            // lineStyle:{
            //   type:"solid"
            // },
            smooth: true
          }
        ],
        textStyle: {
          color: 'rgb(47 84 235)'
          // fontWeight:"bold"
        }
      }
      console.log(JSON.stringify(this.option))
      this.myChart.setOption(this.option)
    },
    getCurrentData() {
      let date = new Date().toLocaleDateString()
      // console.log(typeof(date));
      return date;
    },
    queryOnChange(value, dateString) {
      this.query.queryBeginTime = dateString[0]
      this.query.queryEndTime = dateString[1]
      this.setDefaultTime(this.query.queryBeginTime,this.query.queryEndTime);
    },
    contrastOnChange(value, dateString) {
      this.query.contrastBeginTime = dateString[0]
      this.query.contrastEndTime = dateString[1]
    },
    getDeviceList() {
      const url = 'pipe-network/water_quality/list'
      this.$http.get(url)
        .then(({ data }) => {
          this.deviceList = data
          if (data.length > 0) {
            this.query.qualityId = this.deviceList[0].id
            this.handleDeviceAddressChange(this.query.qualityId)
          }
        })
    },
    setDefaultTime(start,end){
      this.defaulttime = this.moment().format(start,'YYYY-MM-DD') + ' - ' + this.moment().format(end,'YYYY-MM-DD');
      this.firstName = this.defaulttime;
      if(this.legend.length > 0){
        this.legend[0] = this.defaulttime;
      }else{
        this.legend.push(this.defaulttime)
      }
      console.log(JSON.stringify(this.defaulttime));
    },
    handleDeviceAddressChange(value) {
      const url = '/pipe-network/water_quality_historys/list-group-properties'
      const params = { id: value }
      this.query.qualityId = value
      this.$http.get(url, { params })
        .then(({ data }) => {
          this.indexSourceList = []
          if (data.typeResult) {
            this.indexSourceList.push({ type: data.typeResult.type, typeName: data.typeResult.typeName })
            this.subtitle = data.typeResult.typeName
          }
          this.typeResultParameterList = data.typeResult.typeResultParameters

          if (this.typeResultParameterList.length > 0) {
            this.query.filedName = this.typeResultParameterList[0].filedName

          } else {
            this.query.filedName = ''
          }
          if (this.indexSourceList.length > 0) {
            this.query.type = this.indexSourceList[0].type

          } else {
            this.query.type = ''
          }
          // this.$nextTick(() => {
          //   this.echartsInit()
          // })
        })
    },
    handleTypeResultParameterChange(v) {
      this.query.filedName = v
      const fileNameArr = this.typeResultParameterList.filter(item => item.filedName == v)
      if(fileNameArr.length > 0) {
        this.title = fileNameArr[0].name
      }
      // this.$nextTick(() => {
      //   this.echartsInit()
      // })
    },
    queryList() {
      const url = '/pipe-network/water_quality_historys/equipment/history/data'
      const params = this.query
      console.log(params)
      this.$http.get(url, { params })
        .then(({ data }) => {
          if (data && data.length > 0) {
            this.queryDate = data[0].map(item => item.collectTime)
            this.queryData = data[0].map(item => item.data)
          }
          this.$nextTick(() => {
            // console.log(JSON.stringify(this.option))
            this.echartsInit()
          })
        })
    },
    contrast() {
      const url = '/pipe-network/water_quality_historys/equipment/history/data'
      const params = this.query
      let starttime = this.moment().format(this.query.contrastBeginTime, 'YYYY-MM-DD');
      let endtime = this.moment().format(this.query.contrastEndTime, 'YYYY-MM-DD');
      this.defaultcontrasttime = starttime + ' - ' + endtime;
      console.log(params)
      this.$http.get(url, { params })
        .then(({ data }) => {
          if (data && data.length > 0) {
            this.queryDate = data[0].map(item => item.collectTime)
            this.queryData = data[0].map(item => item.data)
            this.contrastDate = data[1].map(item => item.collectTime)
            this.contrastData = data[1].map(item => item.data)
            if(this.legend.length > 0){
              console.log(this.legend.length)
              this.legend[1] = this.defaultcontrasttime
            }else{
              console.log(this.legend.length)
              this.legend.push(this.defaulttime, this.defaultcontrasttime)
            }
            const json = {
              name: this.defaultcontrasttime,
              data: this.contrastData,
              type: 'line',
              label: {
                show: true
              },
              smooth: true
            }
            if(this.option.series.length > 1){
              this.option.series.pop();
              this.option.series.push(json)
            }else{
              this.option.series.push(json)
            }
            this.$nextTick(() => {
              // console.log(JSON.stringify(this.option))
              this.myChart.setOption(this.option)
            })
          }
        })
    }
  }

}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
#chart {
  width: 100%;
  height: 500px;
  margin: 0 auto;
}
</style>